import { render, staticRenderFns } from "./additionalPage.html?vue&type=template&id=6f0b9678&"
import script from "./additionalPage.vue?vue&type=script&lang=js&"
export * from "./additionalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports